<template>
  <div>
    <el-form
      class="mt-2 task-form"
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="mini"
      label-width="130px"
      label-position="left"
    >
      <div class="el-form-row">
        <el-form-item :label="'任务概要'" prop="tskOverview">
          <el-input
            v-model="formData.tskOverview"
            :maxlength="200"
            show-word-limit
            clearable
            :readonly="disabled"
            @change="valueChange"
          />
        </el-form-item>
      </div>

      <div class="el-form-row">
        <el-form-item :label="'经办人'" prop="tskBy">
          <dict-select
            v-if="!disabled"
            v-model="formData.tskBy"
            :selectedLabel.sync="formData.tskByName"
            url="/master/common/dict/baseUserSelect"
            filterable
            clearable
            @change="valueChange"
            size="mini"
          />
          <el-input v-else v-model="formData.tskByName" readonly />
        </el-form-item>
        <el-form-item
          :label="'任务编号'"
          prop="tskInfoNo"
          style="max-width: 40%"
        >
          <el-input
            v-model="formData.tskInfoNo"
            show-word-limit
            clearable
            readonly
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="'截止时间'" prop="tskEndDate">
          <el-row v-if="!disabled" :gutter="5">
            <el-col :span="12">
              <!-- <dict-select
                v-model="formData.tskTimeZone"
                url="/master/common/dict/biz"
                :body="{ dictType: 'meetingTimeZone' }"
                :placeholder="$l('form_placeholder_meetingTimeZone')"
                size="mini"
                filterable
                clearable
                @change="valueChange"
              /> -->
              <TimezoneSelect
                v-model="formData.tskTimeZone"
                size="mini"
                @change="valueChange"
              />
            </el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="formData.tskEndDate"
                type="date"
                format="yyyy/MM/dd"
                value-format="yyyy/MM/dd"
                style="max-width: 100%"
                :placeholder="$l('INDEX.tips_select_date')"
                @change="valueChange"
              />
            </el-col>
            <el-col :span="6">
              <el-time-select
                v-model="formData.tskEndTime"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45',
                }"
                style="max-width: 100%"
                @change="valueChange"
                :placeholder="$l('INDEX.tips_select_time')"
              />
            </el-col>
          </el-row>

          <el-input v-else v-model="formData.tskTimeZone" readonly />
        </el-form-item>
      </div>

      <div class="el-form-row" v-if="taskLocalTime">
        <el-form-item :label="$l('form_label_localTime') || 'Local Time'">
          <el-input :value="taskLocalTime" readonly />
        </el-form-item>
      </div>

      <div class="el-form-row">
        <el-form-item :label="'优先级'">
          <el-radio-group v-if="!disabled" v-model="formData.tskImportantLevel">
            <el-radio-button
              v-for="opt in options"
              :key="opt.value"
              :label="opt.value"
            >
              {{ opt.label }}
            </el-radio-button>
          </el-radio-group>

          <el-tag
            v-else
            style="margin: 6px 0 6px 15px"
            size="mini"
            effect="dark"
            :type="formData.tskImportantLevel"
          >
            {{ formData.tskImportantLevel || 'Medium' }}
          </el-tag>
        </el-form-item>
        <el-form-item :label="'状态'" style="max-width: 40%">
          <el-tag
            v-if="formData.v_tskStatus"
            size="mini"
            style="margin: 6px 0 6px 15px"
            :type="
              formData.tskStatus === 'N' || formData.tskStatus === 'A'
                ? 'info'
                : formData.tskStatus === 'U'
                ? 'waring'
                : formData.tskStatus === 'C'
                ? 'success'
                : formData.tskStatus === 'Y'
                ? 'danger'
                : ''
            "
          >
            {{ formData.v_tskStatus || '' }}
          </el-tag>
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="'任务描述'" prop="tskDescription">
          <TopicsEditor
            v-model="formData.tskDescription"
            :disabled="disabled"
            @change="valueChange"
          />
        </el-form-item>
      </div>
      <div class="el-form-row el-form-todolist">
        <el-form-item>
          <template #label>
            <el-button
              v-if="!disabled"
              type="primary"
              size="mini"
              plain
              @click.stop="$refs.todoList.add()"
              style="pointer-events: auto;"
            >
              {{ $l('btn_addTodo') || '添加待办' }}
            </el-button>
            <div v-else><br /></div>
          </template>
          <div class="px-2 py-3 m-0">
            <TodoList
              ref="todoList"
              :tskInfoCode="taskCode"
              :disabled="disabled"
              @valueChange="valueChange"
            />
          </div>
        </el-form-item>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import TopicsEditor from './topics-editor'
import TodoList from './todo-list'
import TimezoneSelect from '../timezone-select'
const initForm = { tskImportantLevel: 'Medium', tskType: 'T' }
export default {
  mixins: [EditLoading],
  components: { TopicsEditor, TodoList, TimezoneSelect },
  props: {
    disabled: { type: Boolean, default: false },
    expoMeetingCode: { type: String, default: '' },
    taskCode: { type: String, default: '' },
    expoInfoCode: { type: String, default: '' },
    selectionCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { ...initForm },
      options: [
        { label: this.$l('radio_label_high') || 'High', value: 'High' },
        { label: this.$l('radio_label_medium') || 'Medium', value: 'Medium' },
        { label: this.$l('radio_label_low') || 'Low', value: 'Low' },
      ],
      valueChangeFlag: false,
      backDialogVisible: false,

      rules: {
        tskTimeZone: [{ trigger: 'change', required: true, message: ' ' }],
        tskEndDate: [
          { trigger: 'change', required: true, message: ' ' },
          {
            validator: (rule, value, callback) => {
              const { tskTimeZone, tskEndTime } = this.formData
              if (!value || !tskTimeZone || !tskEndTime) {
                return callback(new Error(' '))
              }
              callback()
            },
          },
        ],
        tskBy: [{ trigger: 'change', required: true, message: ' ' }],
        customerName: [{ trigger: 'blur', required: true, message: ' ' }],
        tskOverview: [{ trigger: 'blur', required: true, message: ' ' }],
        tskDescription: [{ trigger: 'blur', required: true, message: ' ' }],
        tskType: [{ trigger: 'change', required: true, message: ' ' }],
        attendanceCodeList: [
          { trigger: 'change', required: true, message: ' ' },
          {
            validator: (rule, value, callback) => {
              if (!value?.length) return callback(new Error(' '))
              callback()
            },
          },
        ],
      },
      localTimeZone: '',
    }
  },
  computed: {
    taskLocalTime() {
      const { taskLocalTimeZone, tskLocalDate, tskLocalEndTime } = this.formData
      return [taskLocalTimeZone, tskLocalDate, tskLocalEndTime]
        .filter(Boolean)
        .join(' ')
    },
  },
  watch: {
    taskCode() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const localTimeZone = await this.loadLocalTimeZone()
      const get = async () => {
        if (!this.taskCode) return { ...initForm }

        const res = await this.$api
          .tskInfoDetailApi({ tskInfoCode: this.taskCode, localTimeZone })
          .catch(() => null)
        return res?.body || {}
      }

      this.formData = await get()
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    async validate() {
      const result = await validate.formValidate([this.$refs.form])
      const listResult = await this.$refs.todoList.validate()
      return result && listResult
    },
    async save() {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const listTodo = this.$refs.todoList.get()

      if (this.loadingOpen()) return
      const res = await this.$api
        .expoTskInfoMeetingSaveApi({
          ...this.formData,
          expoInfoCode: this.expoInfoCode,
          expoMeetingCode: this.expoMeetingCode,
          selectionCode: this.selectionCode,
          meetingTaskNode: 'E',
          listTodo,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.backDialogVisible = false
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.backDialogVisible = false
      this.valueChangeFlag = false
      this.$emit('reload')
      this.taskCode = body
      this.getData()
    },
    valueChange() {
      this.valueChangeFlag = true
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      if (this.valueChangeFlag) {
        this.backDialogVisible = true
      } else {
        this.close()
        return
      }
    },
    close() {
      this.valueChangeFlag = false
      this.backDialogVisible = false
      this.$emit('close')
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form.task-form {
    .el-form-row {
      display: flex;
      border: 1px solid #ebeef5;
      border-top: none;
      border-left: none;
      .el-form-item {
        margin: 0 !important;
        position: relative;
        width: 100%;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
        }

        .el-form-item__content {
          padding: 0 5px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;
          > div {
            margin: 3.2px 0;
          }
          > .el-input {
            input[readonly] {
              border: none;
              background-color: #fff;
              color: #606266;
              cursor: auto;
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
          .no-error {
            .el-input__inner {
              border-color: #dcdfe6 !important;
            }
          }
          .el-range-input {
            width: 34%;
          }
          .el-range-separator {
            width: 11%;
            color: #606266;
          }

          .el-date-editor .el-input__inner {
            text-align: center;
          }
        }
      }
    }

    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
  }
}

::v-deep {
  .el-tag--High {
    color: white;
    background-color: #fa5c7c;
    border: none;
  }
  .el-tag--Medium {
    color: white;
    background-color: #6c757d;
    border: none;
  }
  .el-tag--Low {
    color: white;
    background-color: #13cf97;
    border: none;
  }
  .el-tag--Y {
    color: #fa561f;
    background-color: #fff2e8;
    border-color: rgba($color: #fa561f, $alpha: 0.6);
  }
  .el-form-todolist {
    .el-form-item__label {
      pointer-events: none;
    }
  }
}
</style>
